import dayjs from 'dayjs'
import zip from 'lodash/zip'
import zipObject from 'lodash/zipObject'
import getOverlappingIndicesList from './getOverlappingIndicesList'

const getInsertionOrderBudgetViolations = (
  insertionOrderBudget,
  campaignBudgets,
) => {
  const getZeroBudgetViolations = () =>
    campaignBudgets.map(campaignBudget => campaignBudget.budget <= 0)
  const getOverBudgetViolations = () =>
    campaignBudgets.map(
      campaignBudget =>
        insertionOrderBudget.summary.budget < campaignBudget.budget,
    )
  const getReversePeriodViolations = () =>
    campaignBudgets.map(campaignBudget =>
      dayjs(campaignBudget.startTime).isAfter(campaignBudget.endTime),
    )
  const getOverlappings = () => getOverlappingIndicesList(campaignBudgets)

  if (!insertionOrderBudget.canEditCampaignBudgets)
    return [
      {
        reversePeriod: false,
        zeroBudget: false,
        overBudget: false,
        overlapping: [],
      },
    ]
  return zip(
    getReversePeriodViolations(),
    getZeroBudgetViolations(),
    getOverBudgetViolations(),
    getOverlappings(),
  ).map(invalids => {
    return zipObject(
      ['reversePeriod', 'zeroBudget', 'overBudget', 'overlapping'],
      invalids,
    )
  })
}

export default getInsertionOrderBudgetViolations
